import { gql } from '@apollo/client';

export const SAVE_INSURANCE_DOCUMENT_LIST_TEMPLATE = gql`
  mutation saveInsuranceDocumentListTemplate($input: SaveInsuranceDocumentListTemplateInput!) {
    saveInsuranceDocumentListTemplate(input: $input)
  }
`;

export const DELETE_INSURANCE_DOCUMENT_LIST_TEMPLATE = gql`
  mutation deleteInsuranceDocumentListTemplate($input: DeleteInsuranceDocumentListTemplateInput!) {
    deleteInsuranceDocumentListTemplate(input: $input)
  }
`;
